import {Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from "@angular/core";
import {Notifications, NotificationType} from "../../../../../tools/notifications/notifications";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {DoctorSelectorService} from "../../../doctor-selector/doctor-selector.service";
import {ReassignTechnicianService} from "./reassign-technician.service";
import {finalize} from "rxjs/operators";
import {FoundMeasurement} from "../../../found-measurement";
import {AuthenticationService} from "../../../../authentication/authentication.service";
import {canReassignTechnician} from "./can-reassign-technician";

@Component({
    selector: "app-reassign-technician",
    templateUrl: "./reassign-technician.component.html",
    providers: [DoctorSelectorService],
    standalone: false
})
export class ReassignTechnicianComponent {

  @Input() foundMeasurement!: FoundMeasurement;

  @Output() reassignCompleted = new EventEmitter<FoundMeasurement>();

  modalRefReassignTechnicianConfirm: BsModalRef | undefined;
  @ViewChild("templateSelectTechnician") templateSelectTechnician!: TemplateRef<any>;

  isReassignInProgress = false;

  constructor(
    private readonly modalService: BsModalService,
    public readonly doctorSelectorService: DoctorSelectorService,
    private readonly reassignTechnicianService: ReassignTechnicianService,
    private readonly notifications: Notifications,
    private readonly authenticationService: AuthenticationService
  ) {
  }

  onReassignClick() {
    this.modalRefReassignTechnicianConfirm = this.modalService.show(this.templateSelectTechnician, {
      class: "modal-sm",
    });
  }

  onConfirmReassign(technicianId: string) {
    this.isReassignInProgress = true;
    this
      .reassignTechnicianService
      .reassign(
        {
          measurementId: this.foundMeasurement.id,
          technicianId: Number(technicianId)
        }
      )
      .pipe(finalize(() => {
        this.isReassignInProgress = false;
      }))
      .subscribe({
        next: (measurement: FoundMeasurement) => {
          this.reassignCompleted.emit(measurement);
          this.modalRefReassignTechnicianConfirm!.hide();
        },
        error: () => {
          this.notifications.addNotification(NotificationType.ERROR, "reassignTechnicianFailedNotification");
        }
      });
  }

  shouldShowButton() {
    return canReassignTechnician(
      this.foundMeasurement.status,
      this.authenticationService.getCurrentAuthenticatedUser()!.role,
      this.foundMeasurement.technicianAssignType
    );
  }
}

export interface ReassignTechnicianParams {
  measurementId: number;
  technicianId: number;
}
